import Link from "next/link";
import Image from "next/image";
import MultimediaLoop from "./MultimediaLoop";
import { type ArticlePreviewType } from "~/types";
import Share from "../Article/Share";
import Print from "../Article/Print";
import { useSession } from "next-auth/react";
import Pagination, { usePagination } from "@components/Pagination";
import CategoryArticle from "../CategoryArticle";
import useLoginURL from "@hooks/useLoginURL";
const DEFAULT_ITEMS_PER_PAGE = 12;

const PodcastLayout = (props) => {
  const {
    categorySlug,
    podcastArticles,
    subCategory,
    parentCategoryName,
    parentCategorySlug,
  } = props;
  const term = subCategory?.find((item) => item.slug === categorySlug);
  const termName = term?.name;
  const termThumb = term?.img;
  const termDescription = term?.description;
  const termSoundcloud = term?.soundcloud;
  const session = useSession();
  const isAuthenticated = session?.status === "authenticated";
  const articlesShow = usePagination(podcastArticles, DEFAULT_ITEMS_PER_PAGE);
  const loginURL = useLoginURL();
  const termArr = { main: [{ name: term.name, slug: term.slug }], sub: {} };
  console.log(termArr);
  return (
    <section className="-mt-12 w-full pb-20 print:pb-0">
      <div className="mx-auto max-w-section py-4 max-xl:px-4 max-xl:pt-20 xl:pb-12 xl:pt-52 print:max-w-none print:px-4 print:pb-0 print:pt-12">
        <div className="mb-12 flex max-lg:flex-wrap-reverse sm:mb-20 sm:text-xl lg:justify-between print:mb-6">
          <div className="flex flex-col gap-2 text-lg sm:text-xl md:text-[22px] print:text-lg">
            <ul>
              <li className="inline">
                <Link
                  className="font-medium text-black"
                  href={parentCategorySlug}
                >
                  {parentCategoryName}
                </Link>
              </li>
            </ul>
          </div>

          <div className="flex items-center justify-end gap-6 max-lg:mb-12 max-lg:w-full md:gap-10 print:hidden">
            <Share title={termName?.replace(/<\/?[^>]+(>|$)/g, "")} />

            <Print />
          </div>
        </div>
        <h1
          className="my-10 text-3xl font-thin md:text-5xl lg:text-6xl print:text-4xl"
          dangerouslySetInnerHTML={{ __html: termName }}
        ></h1>
        {Boolean(termThumb) != null && (
          <div className="mt-14">
            <figure className="rounded-3xl bg-lightLightGray print:w-full print:text-center">
              <Image
                src={termThumb}
                width={1200}
                height={790}
                alt={termName || "immagine di copertina"}
                className="rounded-3xl object-cover mix-blend-multiply print:block print:w-1/3"
                sizes="(min-width: 1300px) 1200px, 100vw"
                priority={true}
              />
            </figure>

            <p className="mt-12 text-xl font-light leading-8">
              {termDescription}
            </p>
          </div>
        )}
      </div>
      <div className="is-layout-constrained  mx-auto max-w-section break-words leading-loose max-xl:px-4 print:max-w-none print:px-4 print:!text-lg">
        <div className="content">
          <MultimediaLoop articles={articlesShow as ArticlePreviewType[]} />
          <div
            className={`mx-auto mt-6 max-w-box px-4 text-center ${
              podcastArticles.length > DEFAULT_ITEMS_PER_PAGE ? "" : "hidden"
            }`}
          >
            <Pagination
              totalResults={podcastArticles.length}
              itemsPerPage={DEFAULT_ITEMS_PER_PAGE}
            />
          </div>
          {termSoundcloud && isAuthenticated && (
            <aside className="my-12 inline-block w-full border-t border-gray p-20">
              <h3 className="mb-12 text-center text-2xl text-black">
                Ascolta il podcast senza interruzioni
              </h3>
              <iframe
                width="100%"
                height="600"
                allow="autoplay"
                src={`${termSoundcloud}&color=%230ca1ba&auto_play=false&hide_related=false&show_comments=false&show_user=false&show_reposts=false&show_teaser=false&visual=true`}
              ></iframe>
            </aside>
          )}
        </div>
        <div className="mx-auto hidden max-w-section px-4 pt-12 print:block print:px-4 print:pt-0">
          <p className="py-6 text-sm text-gray print:text-base">
            <strong>©buddismoesocieta.org</strong> – diritti riservati,
            riproduzione&nbsp;riservata
          </p>
        </div>
      </div>
    </section>
    // <section className="mb-12 ml-auto mr-auto max-w-[832px] px-4">
    //   <div className="flex border-b border-gray">
    //     <h5 className="mx-auto inline-block rounded-t-xl bg-lightBlue px-7 py-1 text-lg font-bold uppercase text-white">
    //       <span>{termName}</span>
    //     </h5>
    //   </div>
    //   <header>
    //     <div className="mt-12 flex justify-between">
    //       <div className="flex">
    //         {parentCategoryName && (
    //           <Link
    //             className="font-bold text-lightBlue"
    //             href={parentCategorySlug}
    //           >
    //             {parentCategoryName}
    //           </Link>
    //         )}
    //       </div>

    //       <div className="flex gap-6 md:gap-10">
    //         <Share title={termName?.replace(/<\/?[^>]+(>|$)/g, "")} />
    //         <Print />
    //       </div>
    //     </div>
    //     <h1
    //       className="my-10 text-center text-4xl font-thin md:text-6xl lg:text-7xl"
    //       dangerouslySetInnerHTML={{ __html: termName }}
    //     ></h1>
    //     {Boolean(termThumb) != null && (
    //       <div className="mt-14">
    //         <figure className="">
    //           <Image
    //             src={termThumb}
    //             width={500}
    //             height={400}
    //             alt={termName}
    //             className="!aspect-4/3 h-full w-full object-cover"
    //             priority
    //           />
    //         </figure>
    //         <p className="mt-6 text-center text-xl font-light leading-8">
    //           {termDescription}
    //         </p>
    //       </div>
    //     )}
    //   </header>
    //   <div className="content">
    //     <MultimediaLoop articles={articlesShow as ArticlePreviewType[]} />
    //     <div
    //       className={`mx-auto mt-6 max-w-box px-4 text-center ${
    //         podcastArticles.length > DEFAULT_ITEMS_PER_PAGE ? "" : "hidden"
    //       }`}
    //     >
    //       <Pagination
    //         totalResults={podcastArticles.length}
    //         itemsPerPage={DEFAULT_ITEMS_PER_PAGE}
    //       />
    //     </div>
    //     {termSoundcloud && isAuthenticated && (
    //       <aside className="my-12 inline-block w-full border-t border-gray p-20">
    //         <h3 className="mb-12 text-center text-2xl font-bold text-lightBlue">
    //           Ascolta il podcast senza interruzioni
    //         </h3>
    //         <iframe
    //           width="100%"
    //           height="600"
    //           allow="autoplay"
    //           src={`${termSoundcloud}&color=%230ca1ba&auto_play=false&hide_related=false&show_comments=false&show_user=false&show_reposts=false&show_teaser=false&visual=true`}
    //         ></iframe>
    //       </aside>
    //     )}
    //   </div>
    // </section>
  );
};
export default PodcastLayout;
